<template>
  <el-dialog
    :visible.sync="dialogShow"
    :modal-append-to-body="false"
    :destroy-on-close="true"
    width="700px"
    custom-class="ap-for-record"
    title="DTU备案"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-alert v-if="step == 1" title type="warning" show-icon :closable="false">
      <template slot="title">
        <div>仅鱼漾与合作伙伴联合研发的通讯终端支持备案</div>
      </template>
    </el-alert>
    <div v-if="step == 1" class="flex-center column">
      <el-upload
        v-loading="uploading"
        drag
        accept=".csv, .xls, .xlsx"
        ref="upload"
        :action="$store.state.commonStore.fileUploadUrl"
        :headers="uploadHeaders"
        :multiple="false"
        :limit="1"
        :on-change="handleChange"
        :file-list="fileList"
        :before-upload="beforeUpload"
        :auto-upload="false"
        :on-error="handleUploadFail"
        :on-success="handleUploadSuccess"
        class="mt"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          <div class="mb">将 Excel 文件拖拽到此处</div>
          <el-button size="mini" type="primary">点击上传</el-button>
        </div>
      </el-upload>
      <div class="mt mb flex-center align-items-center">
        导入格式请参考
        <el-link type="primary" :href="dtuTempleteUrl">DTU备案模板</el-link>
      </div>
    </div>
    <div v-else-if="step == 2" class="flex-center column" style="height: 100%">
      <img class="parse-img" src="@/assets/parse.gif" />
      <div class="font-md">正在解析数据······</div>
    </div>
    <div v-else-if="step == 3" class="flex-center column" style="height: 100%">
      <i class="el-icon-success mb-md" style="font-size: 80px;color: #07c160"></i>
      <div class="mb-sm">
        成功导入
        <span class="text-success">{{ success_arr.length }}</span> 条数据，失败
        <span class="text-danger">{{ fail_arr.length }}</span> 条数据
      </div>
      <el-scrollbar :native="false" class="frames" view-class="el-scrollbar-view">
        <div v-if="fail_arr.length" style="padding-bottom: 6px">
          <div v-for="(item, index) in fail_arr" :key="index" class="text-danger">{{ item }}</div>
        </div>
      </el-scrollbar>
    </div>
    <div v-if="step == 1" slot="footer" class="flex-center">
      <el-button plain @click="dialogShow = false">取消</el-button>
      <el-button type="primary" :disabled="fileList.length == 0" @click="submit()">提交</el-button>
    </div>
    <div v-else-if="step == 3" slot="footer" class="flex-center">
      <el-button plain @click="closeRecoed">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { analysisTemplateApi } from "@/api/ap/apApi";
import { getUploadHeaders } from '@/utils/uploadHeaders';
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    simid: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      uploading: false,
      step: 1,
      dtuTempleteUrl:
        "https://api.frippler.com/attachment/docus/global/dtu_registration_template.xlsx",
      fileList: [],
      fail_arr: [],
      success_arr: [],
    };
  },
  computed: {
    uploadHeaders() {
      return getUploadHeaders(this.$store.getters.accessToken);
    },
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {},
    beforeUpload(file) {
      this.uploading = true;
      this.step = 2;
      return true;
    },
    handleChange(file, filelist) {
      this.fileList = filelist;
    },
    handleUploadFail(err, file, fileList) {
      this.uploading = false;
      this.$message.error("文件上传失败");
    },
    handleUploadSuccess(response, file, fileList) {
      if (!response.errno) {
        analysisTemplateApi({ fileid: response.data.id }).then((res) => {
          this.uploading = false;
          if (!res.errno) {
            this.step = 3;
            this.fail_arr = res.data.fail_arr;
            this.success_arr = res.data.success_arr;
          } else {
            this.uploading = false;
            this.dialogShow = false;
            this.$message.error(res.message);
          }
        });
      } else {
        this.uploading = false;
        this.dialogShow = false;
        this.$message.error(response.message);
      }
    },
    submit() {
      this.$refs.upload.submit();
    },
    closeRecoed() {
      this.dialogShow = false;
      this.$emit("change");
    },
  },
};
</script>

<style lang="scss">
.ap-for-record.el-dialog {
  height: 465px;
  .el-dialog__body {
    height: 341px;
    .parse-img {
      height: 194px;
    }
    .custom-loading {
      width: 2.5em;
      height: 3em;
      border: 3px solid transparent;
      border-top-color: #07c160;
      border-bottom-color: #07c160;
      border-radius: 50%;
      animation: spin-stretch 2s ease infinite;
    }
  }
}

@keyframes spin-stretch {
  50% {
    transform: rotate(360deg) scale(0.4, 0.33);
    border-width: 8px;
  }
  100% {
    transform: rotate(720deg) scale(1, 1);
    border-width: 3px;
  }
}
</style>